import axios from 'axios';
import storage from 'redux-persist/es/storage';

import {
  FETCH_DOWNLOAD_PI_REQUEST,
  FETCH_DOWNLOAD_PI_SUCCESS,
  FETCH_DOWNLOAD_PI_FAILURE,
  FETCH_DOWNLOAD_PI_RESET,
} from '../constants';

export const downloadPIDetails = (data: any) => {
  return async function (dispatch: Function): Promise<void> {
    dispatch(fetchDownloadPIDetailsRequest());
    const baseUrl = `${process.env.REACT_APP_API_URL}/apifabric/quote/customer-pi`;
    const token = await storage.getItem('Token');

    axios
      .get(baseUrl, {
        params: {
          quoteId: data?.quoteId,
          fabricId: data?.fabricId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const PIUrl = response?.data?.data?.response?.fileUrl || '';
        window.open(PIUrl);
        dispatch(fetchDownloadPIDetailsSuccess(response?.data?.data));
      })
      .catch((error) => {
        dispatch(fetchDownloadPIDetailsFailure(error.response));
      });
  };
};
export const fetchDownloadPIDetailsRequest = (): Object => {
  return {
    type: FETCH_DOWNLOAD_PI_REQUEST,
  };
};
export const fetchDownloadPIDetailsSuccess = (downloadPIData: any): Object => {
  return {
    type: FETCH_DOWNLOAD_PI_SUCCESS,
    payload: {
      data: downloadPIData,
    },
  };
};
export const fetchDownloadPIDetailsFailure = (error: any): Object => {
  return {
    type: FETCH_DOWNLOAD_PI_FAILURE,
    payload: {
      error: error,
    },
  };
};

export const fetchDownloadPIReset = (): Object => {
  return {
    type: FETCH_DOWNLOAD_PI_RESET,
  };
};
